export default __webpack_public_path__ + "static/media/img-0022.69232ab7.png";